import { render, staticRenderFns } from "./specialCharacterTip.vue?vue&type=template&id=66a8f76a&"
import script from "./specialCharacterTip.vue?vue&type=script&lang=js&"
export * from "./specialCharacterTip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66a8f76a')) {
      api.createRecord('66a8f76a', component.options)
    } else {
      api.reload('66a8f76a', component.options)
    }
    module.hot.accept("./specialCharacterTip.vue?vue&type=template&id=66a8f76a&", function () {
      api.rerender('66a8f76a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/specialCharacterTip.vue"
export default component.exports